<template>
  <draggable
    :options="{ forceFallback: true, sort: true }"
    :group="`${storeName}.draggin`"
    v-model="dragginData"
    element="tbody"
    class="draggable-container"
  >
    <tr
      v-for="(row, i) in data"
      :key="i"
      @click.stop="onClickRow(row)"
      :class="{ 'selected-row': isRowSelected(row) }"
    >
      <td v-if="isSelectable">
        <div class="td-content">
          <div
            class="checkbox checkbox-custom checkbox-primary"
            @click.stop="onToggleRowSelection(row)"
          >
            <input
              :disabled="isRowDisabled(row)"
              :checked="isRowSelected(row)"
              type="checkbox"
            />
            <label />
          </div>
        </div>
      </td>

      <td v-for="(header, j) in headers" :key="j">
        <component
          :is="getRowComponent(header)"
          :data="row"
          :header="header"
          :position="i"
          :store-name="storeName"
        />
      </td>
    </tr>

    <tr v-if="data.length == 0">
      <td
        :colspan="
          headers.filter((h) => !h.hidden).length + (isSelectable ? 1 : 0)
        "
        class="empty-table"
      >
        No se encontraron registros
      </td>
    </tr>
  </draggable>
</template>

<script>
import WTSingleRowValue from "./WTSingleRowValue.vue";
import WTButtonsRow from "./WTButtonsRow.vue";
import WTRawHtmlRow from "./WTRawHtmlRow.vue";

import draggable from "vuedraggable";

export default {
  name: "wt-draggable-body",
  components: {
    WTSingleRowValue,
    WTButtonsRow,
    WTRawHtmlRow,
    draggable,
  },
  props: {
    data: {
      type: Array,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    storeName: {
      type: String,
    },
    headers: { type: Array },
    checkboxValidationCallback: { type: Function },
    isSingleSelectionMode: { type: Boolean, default: false },
    clickToSelect: { type: Boolean, default: false },
  },
  methods: {
    getRowComponent(header) {
      // CHECK HEADER COMPONENT PROP
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!header.component) {
        return header.component;
      }

      // CHECK HEDAER BUTTONS PROP
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!header.buttons) {
        return "WTButtonsRow";
      }

      // CHECK FOR FORMATTER PROP
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!header.formatter) {
        return "WTRawHtmlRow";
      }

      return "WTSingleRowValue";
    },
    isRowSelected(row) {
      return (
        this.state.selection.findIndex(
          (item) => JSON.stringify(item) == JSON.stringify(row)
        ) > -1
      );
    },
    isRowDisabled(row) {
      if (this.checkboxValidationCallback) {
        return this.checkboxValidationCallback(row);
      }

      return false;
    },
    onToggleRowSelection(row) {
      this.dispatch("selectRow", {
        row,
        isSingleSelection: this.isSingleSelectionMode,
      });
    },
    onClickRow(row) {
      if (this.clickToSelect && !this.isRowDisabled(row)) {
        this.onToggleRowSelection(row);
      }

      this.$emit("onRowClicked", row);
    },
    dispatch(action, payload) {
      this.$store.dispatch(`${this.storeName}/table/${action}`, payload);
      this.$store.dispatch(`${this.storeName}/table/emitEvent`, {
        name: "onDraggedItem",
      });
    },
  },
  computed: {
    state() {
      return this.$propertyByString(this.$store.state, this.storeName).table;
    },
    dragginData: {
      get() {
        return this.state.drawData;
      },
      set(newList) {
        this.dispatch("dragData", newList);
      },
    },
  },
};
</script>
